module.exports = __webpack_public_path__ + "static/media/sweetalert2.6c4ae243.scss";


//////////////////
// WEBPACK FOOTER
// ./node_modules/sweetalert2/src/sweetalert2.scss
// module id = 361
// module chunks = 0